/* ============
 * Routes File
 * ============
 *
 * The routes and redirects are defined in this file.
 */

import permissionKeys from '@/constants/_permissions';
import modules from '@/constants/_modules';

export default [
  /** Home
  {
    path: '/home',
    name: 'home.index',
    component: () => import('@/views/Home/Index.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
      module: modules.import,
      breadcrumb: [
        { name: 'Home', link: '/' }
      ]
    }
  }, * */
  // Account
  {
    path: '/account',
    name: 'account.index',
    component: () => import('@/views/Account/Index.vue'),

    // If the user needs to be authenticated to view this page.
    meta: {
      auth: true
    }
  },

  // Login
  {
    path: '/login',
    name: 'login.index',
    component: () => import('@/views/Login/Index.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      guest: true
    }
  },

  // Register
  {
    path: '/register',
    name: 'register.index',
    component: () => import('@/views/Register/Index.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      guest: true
    }
  },

  // Careplan
  {
    path: '/careplan',
    name: 'careplan.index',
    component: () =>
      import('@/views/CarePlan/Index.vue'),
    meta: {
      auth: true,
      module: modules.CAREPLAN,
      permission: permissionKeys.VIEW,
      breadcrumb: [{
        name: 'Care Plan',
        link: 'careplan.index'
      }]
    }
  },
  // Create Careplan
  {
    path: '/careplan/create',
    name: 'careplan.create',
    component: () =>
      import('@/views/CarePlan/Create/Index.vue'),
    meta: {
      auth: true,
      module: modules.CAREPLAN,
      permission: permissionKeys.CREATE,
      breadcrumb: [{
        name: 'Care Plan',
        link: 'careplan.index'
      },
      {
        name: 'Create'
      }
      ]
    }
  },
  // Edit Careplan
  {
    path: '/careplan/edit/:id',
    name: 'careplan.edit',
    component: () =>
      import('@/views/CarePlan/Edit/Index.vue'),
    meta: {
      auth: true,
      module: modules.CAREPLAN,
      permission: permissionKeys.EDIT,
      breadcrumb: [{
        name: 'Care Plan',
        link: 'careplan.index'
      },
      {
        name: 'Edit'
      }
      ]
    }
  },
  // View Careplan
  {
    path: '/careplan/view/:id',
    name: 'careplan.view',
    component: () =>
      import('@/views/CarePlan/View/Index.vue'),
    meta: {
      auth: true,
      module: modules.CAREPLAN,
      permission: permissionKeys.VIEW,
      breadcrumb: [{
        name: 'Care Plan',
        link: 'careplan.index'
      },
      {
        name: 'View'
      }
      ]
    }
  },
  // View Careplan template
  {
    path: '/careplan/view/template/:id',
    name: 'careplan.viewTemplate',
    component: () =>
      import('@/views/CarePlan/Clone/Index.vue'),
    meta: {
      auth: true,
      module: modules.CAREPLAN,
      permission: permissionKeys.VIEW,
      breadcrumb: [{
        name: 'Care Plan',
        link: 'careplan.index'
      },
      {
        name: 'View'
      }
      ]
    }
  },

  // Patient List
  {
    path: '/patientList',
    name: 'patientList.index',
    component: () =>
      import('@/views/PatientList/Index.vue'),
    meta: {
      auth: true,
      module: modules.PATIENTLIST,
      permission: permissionKeys.VIEW,
      breadcrumb: [{
        name: 'Patients list',
        link: 'patient.index'
      }]
    }
  },

   // Follow up Patient List
   {
    path: '/followUpPatientList',
    name: 'followUpPatientList.index',
    component: () =>
      import('@/views/PatientList/List/Index.vue'),
    meta: {
      auth: true,
      module: modules.FOLLOWUP,
      permission: permissionKeys.CREATE,
    }
  },

  {
    path: '/patientList/view/:id',
    name: 'patientList.view',
    component: () =>
      import('@/views/PatientList/View/Index.vue'),
    meta: {
      auth: true,
      module: modules.PATIENTLIST,
      permission: permissionKeys.VIEW,
      breadcrumb: [{
        name: 'Patients list',
        link: 'patient.index'
      },
      {
        name: 'View'
      }
      ]
    }
  },
  // Patient Progress
  {
    path: '/patientProgress',
    name: 'patientProgress.index',
    component: () =>
      import('@/views/PatientProgress/Index.vue'),
    meta: {
      auth: true,
      module: modules.PATIENT,
      permission: permissionKeys.PATIENTPROGRESS,
      breadcrumb: [{
        name: 'Patient Progress',
        link: 'patientProgress.index'
      }]
    }
  },

  // Users List
  {
    path: '/users',
    name: 'user.index',
    component: () =>
      import('@/views/User/Index.vue'),
    meta: {
      auth: true,
      module: modules.USER,
      permission: permissionKeys.VIEW,
      breadcrumb: [{
        name: 'Users',
        link: 'user.index'
      }]
    }
  },

  // Groups List ***********
  {
    path: '/groups',
    name: 'group.index',
    component: () =>
      import('@/views/Group/Index.vue'),
    meta: {
      auth: true,
      module: modules.GROUP,
      permission: permissionKeys.VIEW,
      breadcrumb: [{
        name: 'Groups',
        link: 'group.index'
      }]
    }
  },

  // Groups Assign ***********
  {
    path: '/groups/assign/:id',
    name: 'group.assign',
    component: () =>
      import('@/views/Group/Assign/Index.vue'),
    meta: {
      auth: true,
      module: modules.GROUP,
      permission: permissionKeys.VIEW,
      breadcrumb: [
        { name: 'Groups', link: 'group.index' },
        { name: 'GroupsAssign' }
      ]
    }
  },

  // Profile
  {
    path: '/profile',
    name: 'profile.index',
    component: () =>
        import('@/views/Profile/Index.vue'),
    meta: {
      auth: true,
      module: modules.PROFILE,
      permission: permissionKeys.VIEW,
      breadcrumb: [
        { name: 'Profile', link: 'profile.index' }
      ]
    }
  },

  // Patient
  {
    path: '/patient',
    name: 'patient.index',
    component: () =>
        import('@/views/Patient/Index.vue'),
    meta: {
      auth: true,
      module: modules.PATIENT,
      permission: permissionKeys.VIEW,
      breadcrumb: [
        { name: 'Patients', link: 'patient.index' }
      ]
    }
  },

  // User Create
  {
    path: '/userCreate',
    name: 'user.create',
    component: () =>
      import('@/views/User/Create/Index.vue'),
    meta: {
      auth: true,
      module: modules.USER,
      permission: permissionKeys.CREATE,
      breadcrumb: [{
        name: 'Create user',
        link: 'user.create'
      }]
    }
  },

  // User Edit
  {
    path: '/users/edit/:id',
    name: 'user.edit',
    component: () =>
      import('@/views/User/Modify/Index.vue'),
    meta: {
      auth: true,
      module: modules.USER,
      permission: permissionKeys.EDIT,
      breadcrumb: [
        { name: 'Users', link: 'user.index' },
        { name: 'User Edit' }]
    }
  },

  // User View
  {
    path: '/user/view/:id',
    name: 'user.view',
    component: () =>
        import('@/views/User/Modify/Index.vue'),
    meta: {
      auth: true,
      view: true,
      module: modules.USER,
      permission: permissionKeys.VIEW,
      breadcrumb: [
        { name: 'Users', link: 'user.index' },
        { name: 'User View' }]
    }
  },

 // Patient Create
  {
    path: '/patientCreate',
    name: 'patient.create',
    component: () =>
      import('@/views/Patient/Create/Index.vue'),
    meta: {
      auth: true,
      module: modules.PATIENT,
      permission: permissionKeys.CREATE,
      breadcrumb: [{
        name: 'Create patient',
        link: 'patient.create'
      }]
    }
  },

  // Patient modify
  {
    path: '/patient/edit/:id',
    name: 'patient.modify',
    component: () =>
      import('@/views/Patient/Modify/Index.vue'),
    meta: {
      auth: true,
      module: modules.FOLLOWUP,
      permission: permissionKeys.CREATE,
      breadcrumb: [{
        name: 'Update patient',
        link: 'patient.modify'
      }]
    }
  },

  // Landing Page
  {
    path: '/landing',
    name: 'landing.index',
    component: () =>
    import('@/views/LandingPage/Index.vue'),
    meta: {
      guest: true
    }
  },

  // Alert
  {
    path: '/alert',
    name: 'alert.index',
    component: () => import('@/views/Alert/Index.vue'),
    meta: {
      module: modules.ALERT,
      permission: permissionKeys.VIEW,
      auth: true,
      breadcrumb: [
        { name: 'Alerts', link: 'alert.index' }
      ]
    }
  },

   // Follow ups
   {
    path: '/followUp',
    name: 'followUp.index',
    component: () => import('@/views/Alert/Index.vue'),
    meta: {
      module: modules.FOLLOWUP,
      permission: permissionKeys.CREATE,
      auth: true,
    }
  },

  // Delegates
  {
    path: '/careGivers',
    name: 'delegates.index',
    component: () => import('@/views/Delegates/Index.vue'),
    meta: {
      module: modules.DELEGATE,
      permission: permissionKeys.VIEW,
      auth: true,
      breadcrumb: [
        { name: 'careGivers', link: 'delegates.index' }
      ]
    }
  },

  // Messages
  {
    path: '/message',
    name: 'message.index',
    component: () => import('@/views/Message/Index.vue'),
    meta: {
      module: modules.PATIENTMESSAGE,
      permission: permissionKeys.VIEW,
      auth: true,
      breadcrumb: [
        { name: 'message', link: 'message.index' }
      ]
    }
  },

  // Reports
  {
    path: '/reports',
    name: 'reports.index',
    component: () => import('@/views/Reports/Index.vue'),
    meta: {
      module: modules.REPORTS,
      permission: permissionKeys.VIEW,
      auth: true,
      breadcrumb: [
        { name: 'reports', link: 'reports.index' }
      ]
    }
  },


  // Rootpage
  {
    path: '/',
    redirect: '/landing'
  },
  // Default Page
  {
    path: '/*',
    redirect: '/landing'
  }
];
